module.exports = __webpack_public_path__ + "static/img/jf1.8d4e11a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/jf1.png
// module id = ouxK
// module chunks = 11